import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import FctvaComponent from '../../../components/Mouvement/Panel/FctvaComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class FctvaPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.FCTVA;
		this.icon = { name: 'euro' };
	}

	getLibelle = () => 'FCTVA';

	isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.fctva);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<FctvaComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default FctvaPanel;
